/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Resetpasswordfailed2Inputs */

const zh_auth_resetpasswordfailed2 = /** @type {(inputs: Auth_Resetpasswordfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码重置失败`)
};

const en_auth_resetpasswordfailed2 = /** @type {(inputs: Auth_Resetpasswordfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to reset password`)
};

const es_auth_resetpasswordfailed2 = /** @type {(inputs: Auth_Resetpasswordfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al restablecer la contraseña`)
};

/**
* | output |
* | --- |
* | "Failed to reset password" |
*
* @param {Auth_Resetpasswordfailed2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_resetpasswordfailed2 = /** @type {((inputs?: Auth_Resetpasswordfailed2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Resetpasswordfailed2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_resetpasswordfailed2(inputs)
	if (locale === "en") return en_auth_resetpasswordfailed2(inputs)
	return es_auth_resetpasswordfailed2(inputs)
});
export { auth_resetpasswordfailed2 as "auth_resetPasswordFailed" }